import React from 'react';
import * as R from 'ramda';
import ReactPlayer from 'react-player';
import classNames from 'classnames';

// Components
import {Modal} from 'react-bootstrap';

import ContentModal from '../content_modal';
import ContentDownloadSurvey from '../content_download_survey';
import ContentDownloadSurveyConfirmation from '../content_download_survey_confirmation';
import DistributionButtons from '../distribution_buttons';

const {isAgency, isBrand} = window.sn;
export default class VideoModal extends ContentModal {
    static activePlatforms = ['facebook', 'instagram', 'snapchat'];

    displayModalBodyContent = () => {
        const {show, post} = this.props;
        const {adMode} = this.state;

        if (adMode) {
            return this.displayAdModeContent();
        }

        return (
            <ReactPlayer
                url={post.content_url}
                height="100%"
                width="100%"
                playing={show}
                controls
            />
        );
    };

    displayModalBodyInfo = () => {
        const {close, showDownloadSurvey, showDownloadSurveyThankYou} = this.props;

        const {composingContentComment, adMode} = this.state;

        if (adMode) {
            return this.displayAdModeInfo();
        }

        const downloadContentUrl = this.getDownloadContentUrl();
        const fileName = this.getDownloadFileName();

        const sharingForm = this.displayFacebookPageSharingForm();

        if (!R.isNil(sharingForm)) {
            return sharingForm;
        }

        if (showDownloadSurvey) {
            return (
                <ContentDownloadSurvey
                    brandName={this.props.brandName}
                    campaignName={this.props.campaignName}
                    downloadContentUrl={downloadContentUrl}
                    fileName={fileName}
                    post={this.props.post}
                    handleSubmitContentDownloadSurvey={this.props.handleSubmitContentDownloadSurvey}
                    close={close}
                />
            );
        }

        if (showDownloadSurveyThankYou) {
            return (
                <ContentDownloadSurveyConfirmation
                    downloadContentUrl={downloadContentUrl}
                    fileName={fileName}
                />
            );
        }

        if (composingContentComment) {
            return this.displayCommentComposer();
        }

        const creatorInfoSection = this.displayCreatorInfoSection();
        const postScore = this.displayPostScore();
        const downloadButton = this.displayDownloadButton();

        return (
            <div>
                {creatorInfoSection}

                <div className="rating-download">
                    {postScore}
                    {downloadButton}

                    <DistributionButtons campaignId={this.props.post.campaign_id} />
                </div>
            </div>
        );
    };

    render() {
        const {show} = this.props;

        const closeButton = this.displayCloseButton();
        const modalBodyContent = this.displayModalBodyContent();
        const modalBodyInfo = this.displayModalBodyInfo();

        return (
            <div>
                <Modal show={show} onHide={this.close} className="video-modal">
                    <Modal.Body>
                        <div className="video-modal-body">
                            <div className="video-modal-body-vid">{modalBodyContent}</div>

                            <div className="video-modal-body-info">
                                {closeButton}
                                {modalBodyInfo}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/video_modal/index.js